import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '../user.service';

@Injectable({
  providedIn: 'root'
})
export class SelectAvatarGuard {
  private user = inject(UserService);
  private router = inject(Router);

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.user.getProfile().pipe(
      map((userInfo) => {
        if (!userInfo || !userInfo.character || !userInfo.character.tribe) {
          this.router.navigate(['user', 'setup']);
          return false;
        }
        return true;
      })
    );
  }
}
